/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ exercise: NonNullable<unknown> }} Progression_PlateauInputs */

const en_us2_progression_plateau = /** @type {(inputs: Progression_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} has stalled for three weeks`)
};

const pt_br2_progression_plateau = /** @type {(inputs: Progression_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} está parado há três semanas`)
};

const es_419_progression_plateau = /** @type {(inputs: Progression_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} lleva tres semanas estancado`)
};

const pt_pt2_progression_plateau = /** @type {(inputs: Progression_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} está estagnado há três semanas`)
};

const fr_fr2_progression_plateau = /** @type {(inputs: Progression_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} stagne depuis trois semaines`)
};

const de_de2_progression_plateau = /** @type {(inputs: Progression_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} stagniert seit drei Wochen`)
};

const it_it2_progression_plateau = /** @type {(inputs: Progression_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} è in stallo da tre settimane`)
};

/**
* | output |
* | --- |
* | "{exercise} has stalled for three weeks" |
*
* @param {Progression_PlateauInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_plateau = /** @type {((inputs: Progression_PlateauInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_PlateauInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_plateau(inputs)
	if (locale === "es-419") return es_419_progression_plateau(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_plateau(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_plateau(inputs)
	if (locale === "de-DE") return de_de2_progression_plateau(inputs)
	if (locale === "it-IT") return it_it2_progression_plateau(inputs)
	return en_us2_progression_plateau(inputs)
});
export { progression_plateau as "progression.plateau" }